// extracted by mini-css-extract-plugin
module.exports = {"container":"SimilarPurchases_container__z1BjU","title":"SimilarPurchases_title__raBK_","itemList":"SimilarPurchases_itemList__vR4lZ","loader":"SimilarPurchases_loader__2txtH"};